<div class="hierarchy-tabs">
  <div
    *ngFor="let item of tabs; let i = index"
    class="ht-block"
    [ngClass]="{ 'ht-selected': item.path === active }"
  >
    <a [routerLink]="item.path">
      {{ item?.title }}
      <i *ngIf="item.iconClass" [class]="item.iconClass" aria-hidden="true"></i>
    </a>
  </div>
</div>
